module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page6 animated fadeIn"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.modal),
      expression: "modal"
    }],
    staticClass: "modal"
  }, [_c('h3', [_vm._v(_vm._s(_vm.items.modal.title))]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "instructions",
    domProps: {
      "innerHTML": _vm._s(_vm.items.modal.text)
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "instructions",
    domProps: {
      "innerHTML": _vm._s(_vm.items.activity.instructions)
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "button forward",
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v(_vm._s(_vm.items.modal.button))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.final),
      expression: "final"
    }],
    staticClass: "modal final"
  }, [_c('h3', [_vm._v(_vm._s(_vm.items.feedback.title))]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', {
    staticClass: "instructions",
    domProps: {
      "innerHTML": _vm._s(_vm.items.feedback.text)
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "button forward",
    on: {
      "click": _vm.showReview
    }
  }, [_vm._v(_vm._s(_vm.items.feedback.button))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.review),
      expression: "!review"
    }],
    staticClass: "container"
  }, [_c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 361.3 234.5"
    },
    attrs: {
      "version": "1.1",
      "id": "Layer_2",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 361.3 234.5",
      "xml:space": "preserve"
    }
  }, [_c('g', [_c('g', [_c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M0.6,139.2c0,0,0.2-0.3,0.6-0.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st1",
    attrs: {
      "d": "M2.3,136.8C15.3,119.1,100.5,10.4,252.6,1.3"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st0",
    attrs: {
      "d": "M253.6,1.3c0.3,0,0.7,0,1-0.1"
    }
  })])]), _vm._v(" "), _c('path', {
    staticClass: "st2",
    attrs: {
      "d": "M312.1,0.7c0,0,20,5,21,21"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st2",
    attrs: {
      "d": "M281.1,21.7c0,0,2,25-30,38"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st2",
    attrs: {
      "d": "M260.1,77.7c0,0,17,15,6,34"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st2",
    attrs: {
      "d": "M223.1,127.7c0,0-35,5-38,46"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st2",
    attrs: {
      "d": "M151.1,169.7c0,0-3-17-28-19"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st2",
    attrs: {
      "d": "M97.1,173.7c0,0,14,60,107,60"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st2",
    attrs: {
      "d": "M260.1,233.7c0,0,33-28,6-74"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st2",
    attrs: {
      "d": "M290.1,132.7c0,0,37-1,47,37"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st2",
    attrs: {
      "d": "M290.1,127.7c0,0,24-27,71-16"
    }
  })]), _vm._v(" "), (_vm.active) ? _c('activate') : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.kpiWarn),
      expression: "kpiWarn"
    }],
    staticClass: "warning animated slideInRight"
  }, [_c('i', {
    staticClass: "fas fa-exclamation"
  }), _vm._v(_vm._s(_vm.items.activity.warning))]), _vm._v(" "), _c('dashboard', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.modal),
      expression: "!modal"
    }],
    attrs: {
      "id": _vm.id,
      "dashValues": _vm.dashValues,
      "units": _vm.units
    }
  }, [_c('div', {
    slot: "warnings"
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.warnings[0]),
      expression: "warnings[0]"
    }],
    staticClass: "fas fa-exclamation warn one"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.warnings[1]),
      expression: "warnings[1]"
    }],
    staticClass: "fas fa-exclamation warn two"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.warnings[2]),
      expression: "warnings[2]"
    }],
    staticClass: "fas fa-exclamation warn three"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.warnings[3]),
      expression: "warnings[3]"
    }],
    staticClass: "fas fa-exclamation warn four"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.warnings[4]),
      expression: "warnings[4]"
    }],
    staticClass: "fas fa-exclamation warn five"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.warnings[5]),
      expression: "warnings[5]"
    }],
    staticClass: "fas fa-exclamation warn six"
  })]), _vm._v(" "), _c('div', {
    slot: "terminal"
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.terminalX[0]),
      expression: "terminalX[0]"
    }],
    staticClass: "fas fa-times terminal one"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.terminalX[1]),
      expression: "terminalX[1]"
    }],
    staticClass: "fas fa-times terminal two"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.terminalX[2]),
      expression: "terminalX[2]"
    }],
    staticClass: "fas fa-times terminal three"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.terminalX[3]),
      expression: "terminalX[3]"
    }],
    staticClass: "fas fa-times terminal four"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.terminalX[4]),
      expression: "terminalX[4]"
    }],
    staticClass: "fas fa-times terminal five"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.terminalX[5]),
      expression: "terminalX[5]"
    }],
    staticClass: "fas fa-times terminal six"
  })])]), _vm._v(" "), _c('ul', {
    staticClass: "locations"
  }, _vm._l((_vm.items.activity.locations), function(item, index) {
    return _c('li', {
      style: ({
        top: item.top + '%',
        left: item.left + '%'
      })
    }, [_c('img', {
      attrs: {
        "src": 'media/page3/' + item.img
      }
    }), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.name))])])
  })), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showEvent && !_vm.terminal),
      expression: "showEvent && !terminal"
    }],
    staticClass: "event",
    style: ({
      top: _vm.eventLocation[_vm.id].top + '%',
      left: _vm.eventLocation[_vm.id].left + '%'
    }),
    on: {
      "click": _vm.event
    }
  }, [_c('i', {
    staticClass: "fas fa-exclamation"
  })]), _vm._v(" "), _c('popup', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.feedback),
      expression: "feedback"
    }],
    attrs: {
      "id": _vm.id
    },
    on: {
      "choose": _vm.choose,
      "tryAgain": _vm.tryAgain,
      "next": _vm.next
    }
  })], 1), _vm._v(" "), _c('terminal-modal', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.terminal),
      expression: "terminal"
    }],
    on: {
      "tryAgain": _vm.replay
    }
  }), _vm._v(" "), (_vm.review) ? _c('review', {
    attrs: {
      "choices": _vm.choices
    },
    on: {
      "dashIndex": _vm.dashIndex
    }
  }, [_c('dashboard', {
    attrs: {
      "id": _vm.id,
      "dashValues": _vm.dashFinal[_vm.dashId],
      "units": _vm.unitsFinal[_vm.dashId]
    }
  }, [_c('div', {
    slot: "warnings"
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.warningsFinal[_vm.dashId][0]),
      expression: "warningsFinal[dashId][0]"
    }],
    staticClass: "fas fa-exclamation warn one"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.warningsFinal[_vm.dashId][1]),
      expression: "warningsFinal[dashId][1]"
    }],
    staticClass: "fas fa-exclamation warn two"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.warningsFinal[_vm.dashId][2]),
      expression: "warningsFinal[dashId][2]"
    }],
    staticClass: "fas fa-exclamation warn three"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.warningsFinal[_vm.dashId][3]),
      expression: "warningsFinal[dashId][3]"
    }],
    staticClass: "fas fa-exclamation warn four"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.warningsFinal[_vm.dashId][4]),
      expression: "warningsFinal[dashId][4]"
    }],
    staticClass: "fas fa-exclamation warn five"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.warningsFinal[_vm.dashId][5]),
      expression: "warningsFinal[dashId][5]"
    }],
    staticClass: "fas fa-exclamation warn six"
  })])])], 1) : _vm._e(), _vm._v(" "), _c('button-replay', {
    on: {
      "replay": _vm.replay
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-39e5550d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/containers/section1/pages/Page6.vue
// module id = 137
// module chunks = 0